import Village from "../assets/Medieval/village.webp";
import Castle from "../assets/Medieval/castle.webp";
import Cave from "../assets/Medieval/cave.webp";
import Farm from "../assets/Medieval/farm.webp";
import Field from "../assets/Medieval/field.webp";
import Forest from "../assets/Medieval/forest.webp";
import Graveyard from "../assets/Medieval/graveyard.webp";
import Harbor from "../assets/Medieval/harbor.webp";
import Mountain from "../assets/Medieval/mountain.webp";
import Sea from "../assets/Medieval/sea.webp";
import Ruins from "../assets/Medieval/ruins.webp";
import Temple from "../assets/Medieval/temple.webp";
import Wasteland from "../assets/Medieval/wasteland.webp";

export function MedievalImageList() {
  return [
    Village,
    Castle,
    Cave,
    Farm,
    Field,
    Forest,
    Graveyard,
    Harbor,
    Mountain,
    Sea,
    Ruins,
    Temple,
    Wasteland,
  ];
}

export function MedievalLocations() {
  const locations = [
    "village",
    "forest",
    "farm",
    "field",
    "mountain",
    "cave",
    "ruins",
    "graveyard",
    "wasteland",
    "temple",
    "castle",
    "harbor",
    "sea",
  ];

  return locations;
}

export function MedievalWorld() {
  const world =
    "It's a fantasy medieval setting within the Kingdom of Eldoria in the year 1237. Magic is known around the world but is rarely used anymore, due to its risk to corrupt the mind. The village Korn is currently being oppressed by the empire of Darvill.";
  return world;
}

export function MedievalIntroduction(language) {
  let introduction;
  switch (language) {
    case "en":
      introduction =
        "In the year 1237, over fields of vibrant green and beneath an endless expanse of sky, the kingdom of Eldoria thrived in the shadow of ancient forests and mighty mountains.\n\nThe once-powerful magic, now feared and hidden, still whispered of unimaginable power.\n\nThe village of Korn, where people once lived peacefully, now lies under the tyranny of Darvill.\n\nWill you, brave soul, rise against the tyranny or succumb to the looming shadow? The fate of Korn rests in your hands.";
      break;
    case "es":
      introduction =
        "En el año 1237, sobre campos de vibrante verde y bajo una vasta extensión de cielo, el reino de Eldoria prosperaba a la sombra de antiguos bosques y majestuosas montañas.\n\nLa magia, otrora poderosa, ahora temida y oculta, aún susurraba acerca de un poder inimaginable.\n\nEl pueblo de Korn, donde la gente vivía en paz, ahora yace bajo la tiranía de Darvill.\n\n¿Te alzarás, alma valiente, contra la tiranía o sucumbirás a la sombra que se avecina? El destino de Korn está en tus manos.";
      break;
    case "fr":
      introduction =
        "En l'an 1237, au-dessus de champs verdoyants et sous une étendue infinie de ciel, le royaume d'Eldoria prospérait à l'ombre de forêts anciennes et de montagnes majestueuses.\n\nLa magie, autrefois puissante, désormais crainte et dissimulée, murmurait encore des promesses d’un pouvoir inimaginable.\n\nLe village de Korn, où les habitants vivaient autrefois en paix, se trouve désormais sous la tyrannie de Darvill.\n\nTe lèveras-tu, âme courageuse, contre la tyrannie ou succomberas-tu à l'ombre menaçante ? Le destin de Korn repose entre tes mains.";
      break;
    case "de":
      introduction =
        "Im Jahr 1237, über Feldern von lebendigem Grün und unter einer weiten Himmelspanne, blühte das Königreich Eldoria im Schatten uralter Wälder und mächtiger Berge.\n\nDie einst mächtige Magie, nun gefürchtet und verborgen, flüsterte dennoch von unsagbarer Macht. \n\nDas Dorf Korn, wo die Menschen einst friedlich lebten, unterliegt nun der Tyrannei Darvills. \n\nWirst du, mutige Seele, dich gegen die Tyrannei erheben oder dem drohenden Schatten erliegen? Das Schicksal von Korn liegt in deinen Händen.";
      break;
    case "zh":
      introduction =
        "公元1237年，在一片生机勃勃的绿色田野之上，广袤无垠的天空之下，埃尔多利亚王国在古老森林和巍峨山脉的阴影中繁荣昌盛。\n\n曾经强大的魔法，如今被人们畏惧并隐藏，仍低声诉说着不可思议的力量。\n\n曾经和平安宁的科恩村，如今沦落在达维尔的暴政之下。\n\n勇敢的灵魂啊，你会挺身而出，反抗暴政，还是屈服于逼近的黑暗阴影？科恩的命运掌握在你的手中。";
      break;
    case "ar":
      introduction =
        "في عام 1237، فوق حقول خضراء نابضة بالحياة وتحت سماء لا حدود لها، ازدهرت مملكة إلدوريا في ظل غابات عتيقة وجبال شامخة.\n\nالسحر الذي كان يومًا قويًا، أصبح الآن مهابًا ومختبئًا، لكنه لا يزال يهمس بقوة لا يمكن تصورها.\n\nقرية كورن، التي عاش سكانها يومًا بسلام، أصبحت الآن تحت طغيان دارفيل.\n\nفهل ستنهض، أيتها الروح الشجاعة، ضد الطغيان، أم ستستسلم للظل المظلم الذي يقترب؟ مصير كورن بين يديك.";
      break;
    case "ru":
      introduction =
        "В 1237 году, над зелеными полями и под бескрайним небом, королевство Эльдория процветало в тени древних лесов и величественных гор.\n\nКогда-то могущественная магия, ныне пугающая и скрытая, всё ещё шепчет о немыслимой силе.\n\nДеревня Корн, где когда-то люди жили в мире, теперь находится под гнётом тирании Дарвилла.\n\nСможешь ли ты, храбрая душа, подняться против тирании или уступишь надвигающейся тьме? Судьба Корна в твоих руках.";
      break;
    case "ja":
      introduction =
        "1237年、緑豊かな畑の上空と果てしない空の下、エルドリア王国は古代の森と壮大な山々の影で繁栄していました。\n\nかつて強力だった魔法は今や恐れられ、隠されていますが、それでも想像を超える力をささやき続けています。\n\nかつて人々が平和に暮らしていたコーン村は、今やダーヴィルの暴政に支配されています。\n\n勇敢な魂よ、あなたは暴政に立ち向かうのか、それとも迫りくる暗黒の影に屈するのか？コーンの運命はあなたの手の中にあります。";
      break;
  }
  return introduction;
}

export function MedievalBackground(location, currentBackground) {
  if (!location) return Village;
  if (location.toLowerCase().includes("village")) return Village;
  else if (location.toLowerCase().includes("castle")) return Castle;
  else if (location.toLowerCase().includes("cave")) return Cave;
  else if (location.toLowerCase().includes("farm")) return Farm;
  else if (location.toLowerCase().includes("field")) return Field;
  else if (location.toLowerCase().includes("forest")) return Forest;
  else if (location.toLowerCase().includes("graveyard")) return Graveyard;
  else if (location.toLowerCase().includes("harbor")) return Harbor;
  else if (location.toLowerCase().includes("mountain")) return Mountain;
  else if (location.toLowerCase().includes("sea")) return Sea;
  else if (location.toLowerCase().includes("ruins")) return Ruins;
  else if (location.toLowerCase().includes("temple")) return Temple;
  else if (location.toLowerCase().includes("wasteland")) return Wasteland;
  else return currentBackground;
}
